<template lang="pug">
  .content
    .content__block.content-teachers
      .content-media-obj.content-default-margin(
        v-for="teacher in teachers"
      )
        .content-media-obj__media
          img(
          v-if="teacher.photo.preview_376x340"
          :src="teacher.photo.preview_376x340"
          )
          img(
          v-else
          src="/img/temp/profile.png"
          )
        .content-media-obj__body
          p
            span.camp-content__subtitle {{teacher.fio}}
            br
            span {{teacher.present_post}}
            br
            span {{teacher.extra}}
</template>

<script>

export default {
  name: "ShiftTeachers",
  props: {
    teachers: {
      type: Array,
      default: () => ([])
    }
  }

};
</script>
